export default {
  "menu": {
    "dashboard": "Dashboard",
    "orders": "Orders",
    "api": {
      "title": "API",
      "apiApps": "API apps",
      "callbacks": "Callbacks",
      "requests": "Requests"
    },
    "profile": {
      "title": "Profile",
      "updateProfile": "Update profile",
      "updatePassword": "Update password"
    },
    "payoutSettings": {
      "title": "Payout settings",
      "withdrawals": "Withdrawal request",
      "wallets": {
        "title": "Withdrawal wallet address",
        "bitcoin": "Bitcoin (BTC)",
        "ethereum": "Ethereum (ETH)",
        "cardano": "Cardano (ADA)",
        "ripple": "Ripple (XRP)",
        "stellar": "Stellar (XLM)"
      },
      "paymentAddresses": "Currency receiving method",
      "xpubAddresses": "Bitcoin (BTC) - XPUB",
      "multisignXpub": "Bitcoin (BTC) - MultiSign",
      "xlm": "Stellar Lument (XLM) - Address",
      "xrp": "Ripple (XRP) - Address",
      "ada": "Cardano (ADA) - Address",
      "eth": "Ethereum (ETH) - Address",
      "neo": "NEO (NEO) - Address",
      "newAddress": "New address",
      "resendConfirmation": "Resend confirmation",
      "walletName": "Wallet name",
      "walletAddress": "Wallet address",
      "confirmBeforeRemove": "Are you sure you want to remove this wallet?",
      "newWallet": "Add new wallet information",
      "editWallet": "Edit wallet information"
    },
    "directPayment": {
      "title": "Direct payment",
      "wallet": "Payment wallet",
      "newKey": "New key",
      "keyName": "Key name",
      "keyValue": "Key value",
      "titleAddXPUB": "Add a new BTC Public Key",
      "labelXpub": "XPUB value",
      "checkAddress": "Check XPUB address",
      "messageCheckAddress": "Please send a small amount to this address to check this XPUB value"
    },
    "apps": "Apps",
    "users": "Users",
    "system": {
      "title": "System",
      "adminUsers": "Admin users",
      "cryptoCurrencies": "Crypto currencies",
      "systemStatus": "System status"
    },
    "selectApp": "Select app"
  },
  "headerMenu": {
    "profile": "Profile",
    "logout": "Log out"
  },
  "updateProfile": {
    "title": "Update profile",
    "fullName": "Full name",
    "phoneCountry": "Phone country code",
    "phone": "Phone",
    "timezone": "Timezone",
    "address": "Address"
  },
  "updatePassword": {
    "title": "Update password",
    "currentPassword": "Current password",
    "newPassword": "New password"
  },
  "button": {
    "edit": "Edit",
    "clear": "Clear",
    "submit": "Submit",
    "save": "Save",
    "cancel": "Cancel",
    "close": "Close",
    "login": "Login",
    "createAnAccount": "Create an account",
    "register": "Register",
    "goToSignIn": "Go to sign in",
    "newRequest": "New request",
    "agree": "Agree",
    "disagree": "Disagree"
  },
  "app": {
    "name": "FG Payment"
  },
  "login": {
    "title": "Sign in",
    "forgotPassword": "Forgot Password?",
    "dontHaveAccount": "Don't have an account?"
  },
  "registration": {
    "title": "Registration",
    "haveAccount": "Already have an account?"
  },
  "forgotPassword": {
    "title": "Recover your password",
    "goBackLogin": "Go back to login",
    "sendResetLink": "Send reset link"
  },
  "resetPassword": {
    "title": "Reset your password",
    "resetButton": "Reset my password"
  },
  "dialog": {
    "order": {
      "titleChangePaid": "Update order to PAID?",
      "confirmUpdate": "Are you sure you want to update this item?",
      "checkBalance": "Check balance",
      "markAsPaid": "Mark as paid",
      "reuseAddress": "Reuse address"
    },
    "withdrawal": {
      "title": "Select wallet to withdrawn",
      "selectCoin": "Select crypto currency",
      "selectWallet": "Select wallet",
      "hintDigits": "There should only be {count} digits at most after the decimal point"
    },
    "export": {
      "selectFormat": "Please select format type"
    },
    "confirmDeleteItem": "Are you sure you want to delete this item?"
  },
  "table": {
    "order": {
      "merchantOrderID": "Merchant Order ID",
      "price": "Price",
      "title": "Title",
      "payAmount": "Pay amount",
      "appName": "App name"
    },
    "withdrawal": {
      "receivedWallet": "Received wallet",
      "requestAmount": "Request amount",
      "receivedAmount": "Received Amount",
      "fee": "Fee"
    },
    "app": {
      "title": "App name",
      "token": "Token",
      "deviation": "Deviation",
      "expiredTime": "Order expired time (Seconds)",
      "newApp": "New app setting",
      "editApp": "Edit app setting"
    },
    "withdrawnAddress": {
      "owner": "Owner"
    }
  },
  "filter": {
    "byStatus": "Filter by Status",
    "byApp": "Filter by App"
  },
  "common": {
    "email": "Email",
    "password": "Password",
    "passwordConfirmation": "Password confirmation",
    "noticeRequiredField": "* indicates required field",
    "status": "Status",
    "createdAt": "Created at",
    "updatedAt": "Updated at",
    "successfully": "Successfully",
    "search": "Search"
  },
  "tooltip": {
    "xpubAddress": "Please get XPUB key with BIP-44 Standard from your wallet. We suggest that you should take this value from cold wallet such as Trezor. As its importance, we suggest that you should do test (make an order and pay with a small amount to make sure that your wallet receive that amount or not) before applying in mass",
    "multisignWallet": "We support Multisignature (multisig) which requires two private keys to sign (authorize) a Bitcoin withdrawal transaction. You need to provide the two XPUB keys in this case. And, as its importance, we suggest that you should do test (make an order and pay with a small amount to make sure that your wallet receive that amount or not) before applying in mass.",
    "xlmPayoutAddress": "To receive XLM, you only need to provide an XLM address. As its importance, we suggest that you should do test (make an order and pay with a small amount to make sure that your wallet receive that amount or not) before applying in mass",
    "xrpPayoutAddress": "To receive XRP, you only need to provide an XRP address. As its importance, we suggest that you should do test (make an order and pay with a small amount to make sure that your wallet receive that amount or not) before applying in mass",
    "refreshData": "Refresh data",
    "filterData": "Filter data",
    "exportData": "Export data",
    "closePanel": "Close panel",
    "remove": "Remove",
    "edit": "Edit",
    "copy": "Copy"
  }
}
